import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import ReactStars from "react-rating-stars-component";
import { MdOutlineStarPurple500 } from "react-icons/md";
import { MdOutlineStarHalf } from "react-icons/md";
import { MdOutlineStarBorderPurple500 } from "react-icons/md";
import { RiDeleteBinLine } from "react-icons/ri";
import { removeFromCart } from "../../../../slices/cartSlice";
import { render } from "react-dom";
import { apiConnector } from '../../../../services/apiconnector';
import { ratingsEndpoints } from '../../../../services/apis';

function RenderCartCourses(props) {
  const { cart } = useSelector((state) => state.cart);

  const dispatch = useDispatch();
  useEffect(() => {
    // dispatch(getAverageRating());
  }, []);

  function ratingChanged() {}
  const [reviews,setReviews] = useState([]);
  useEffect(()=>{
    async function fetchAllReviews()
    { 
        // const response = await apiConnector("GET",ratingsEndpoints.REVIEWS_DETAILS_API);
        // console.log("Response: ",response);

        const {data} = await apiConnector("GET",ratingsEndpoints.REVIEWS_DETAILS_API);

        if(data?.success)
        {
            // console.log("Hi",data?.data)
            
            setReviews(data?.data);
        }

        // console.log("Response1: ",reviews)
    }
    fetchAllReviews();
  },[])
  return (
    <div>
      {cart.map((course, index) => {
        return (
          <div key={index} className="flex max-[450px]:gap-x-5 justify-between p-10 max-[450px]:p-5">
            {/* left section */}
            <div className="flex max-[450px]:flex-col gap-x-5">
              <img src={course?.thumbnail} alt={`course${course.courseName}`} 
                className="w-[250px] max-[450px]:h-[110px] rounded-md"
              />
              <div>
                <p className="text-2xl">{course?.courseName}</p>
                <p className="text-xl text-richblack-200">{course?.category?.name}</p>
                <div className="flex max-[450px]:w-full gap-x-2 items-center justify-center">
                  <p>{reviews?.review}</p>
                  <ReactStars
                    count={5}
                    onChange={ratingChanged}
                    value={reviews?.review}
                    size={24}
                    edit={false}
                    isHalf={true}
                    emptyIcon={<MdOutlineStarPurple500 />}
                    halfIcon={<MdOutlineStarHalf />}
                    fullIcon={<MdOutlineStarBorderPurple500 />}
                    activeColor="#ffd700"
                  />

                  <span>{course?.ratingAndReviews.length} Ratings</span>
                </div>
              </div>
            </div>

            {/* button */}
            <div className="flex flex-col gap-4">
              <button
                onClick={() => {
                  dispatch(removeFromCart(course._id));
                }}
                className="bg-richblack-800 flex text-pink-200 items-center justify-center px-4 py-2 rounded-md"
                >
                <RiDeleteBinLine /> Remove
              </button>
              <p className="text-xl text-yellow-25 font-semibold">Rs.{course?.price}</p>
            </div>
          </div>
        );
      })}
    </div>
  );
}

export default RenderCartCourses;
